import { z } from 'zod';

/**
 * Pro-Nutzer-Anordnung des Start-Dashboards (ADR 0062) — reine Anzeige-Präferenz,
 * KEINE Berechtigung. Das Layout referenziert nur Widget-IDs aus der Registry; der
 * Server erzwingt weiterhin jede einzelne Datenquelle über die Berechtigungen. Ein
 * manipuliertes Layout kann also kein gesperrtes Widget mit Daten füllen.
 */
export const dashboardLayoutSchema = z.object({
  /** Wunsch-Reihenfolge der Widget-IDs. Unbekannte/neue Widgets hängt das Frontend ans Ende. */
  order: z.array(z.string().trim().min(1).max(60)).max(50).default([]),
  /** Vom Nutzer ausgeblendete Widget-IDs. */
  hidden: z.array(z.string().trim().min(1).max(60)).max(50).default([]),
});
export type DashboardLayout = z.infer<typeof dashboardLayoutSchema>;

/** Body für PATCH /auth/me/dashboard-layout — ersetzt das Layout komplett. */
export const updateDashboardLayoutSchema = dashboardLayoutSchema;
export type UpdateDashboardLayoutInput = z.infer<typeof updateDashboardLayoutSchema>;
